export default "__VITE_ASSET__CyeQDDWn__"